import {
	MAIL_LIST_GENERIC_ACTIVITY_LIST_SORT,
	MAIL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/mailList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { MailListItem } from 'src/models/mailList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { SerializedQuery } from 'src/models/query';

interface MailListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	directionFilter: 'combined' | 'in' | 'out';
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	listViewModeLarge: boolean;
	mailListAll: Array<MailListItem>;
	mailListAllSliced: Map<number, Array<MailListItem>>;
	mailListAllTotalCount: number;
	mailListMine: Array<MailListItem>;
	mailListMineSliced: Map<number, Array<MailListItem>>;
	mailListMineTotalCount: number;
	mailListOpen: Array<MailListItem>;
	mailListOpenSliced: Map<number, Array<MailListItem>>;
	mailListOpenTotalCount: number;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	today: string;
}

function state(): MailListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
			[ActivityListTypeEnum.OPEN, ''],
		]),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		directionFilter: 'combined',
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		listViewModeLarge:
			localStorage.getItem(MAIL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(MAIL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		mailListAll: [],
		mailListAllSliced: new Map<number, Array<MailListItem>>(),
		mailListAllTotalCount: 0,
		mailListMine: [],
		mailListMineSliced: new Map<number, Array<MailListItem>>(),
		mailListMineTotalCount: 0,
		mailListOpen: [],
		mailListOpenSliced: new Map<number, Array<MailListItem>>(),
		mailListOpenTotalCount: 0,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.MINE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.OPEN, { page: 1, rowsPerPage: 100 }],
		]),
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(MAIL_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(MAIL_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
		today: new Date().toISOString().split('T')[0],
	};
}

export default state;
